<template>
  <v-container grid-list-xl>
    <v-layout
      row
      wrap
    >
      <v-flex
        lg12
        sm12
        xs12
        class="pt-0"
      >
        <Search />
        <v-data-table
          :headers="table.header"
          :items="table.content"
          :item-key="'id'"
          :loading="table.isLoading"
          :items-per-page="table.paginate.inputPage.size"
          :options.sync="pagination"
          :server-items-length="table.total"
          :footer-props="{ showFirstLastPage: true, showCurrentPage: true }"
          @click:row="goToDetail"
        >
          <template #item.tipoPedido="{ item }">
            {{ item.tipoPedido | tipoPedido }}
          </template>
          <template #item.status="{ item }">
            {{ item.status | statusPedido }}
          </template>
          <template #item.dataCriacao="{ item }">
            {{ item.dataCriacao | date }}
          </template>
          <template #item.veiculo="{ item }">
            <span v-text="getLicensePlate(item)" />
          </template>
          <template #item.actions="{ item }">
            <div class="actions-cell">
              <router-link
                :to="{ name: 'pedidos-detail', params: { id: item.id } }"
                title="Visualizar Pedido"
              >
                <v-icon>visibility</v-icon>
              </router-link>

              <v-menu
                v-if="isIndeferido(item)"
                offset-y
                left
                max-width="320"
                :close-on-content-click="false"
              >
                <template #activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    color="error"
                    title="Motivo do Indeferimento"
                    v-bind="attrs"
                    @click.stop
                    v-on="on"
                  >
                    <v-icon>error_outline</v-icon>
                  </v-btn>
                </template>
                <v-card class="indeferimento-card">
                  <v-card-title class="indeferimento-card__title">
                    <v-icon
                      small
                      color="error"
                      class="mr-1"
                    >
                      error_outline
                    </v-icon>
                    Motivo do Indeferimento
                  </v-card-title>
                  <v-card-text class="indeferimento-card__text">
                    {{ getMotivoIndeferimento(item) }}
                  </v-card-text>
                </v-card>
              </v-menu>
              <span
                v-else
                class="actions-cell__spacer"
              />
            </div>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable no-prototype-builtins */
import { mapActions, mapState } from "vuex";
import Search from "./Search";
import PedidoService from '@/services/sit-pedidos/pedido.service'

// Vuex Store - Sit Pedidos (mapping actions and states)
const actions = mapActions('sitPedidos', ['setTableContent', 'setTableIsLoading', 'setTableTotals', 'clearTable', 'setTablePagination'])
const state = mapState('sitPedidos', ['table'])

// Status que habilita o ícone de indeferimento na coluna de ações
const STATUS_INDEFERIDO = 'INDEFERIDO'

// Nomes possíveis do campo que traz o motivo do indeferimento no retorno do GraphQL.
// Assim que o nome real for confirmado, basta deixar apenas ele nesta lista.
const MOTIVO_INDEFERIMENTO_KEYS = [
  'motivoIndeferimento',
  'justificativaIndeferimento',
  'descricaoIndeferimento',
  'motivo',
  'justificativa',
  'observacao'
]

export default {
  components: {
    Search
  },
  data: () => ({
    pagination: null
  }),
  computed: {
    ...state
  },
  watch: {
    pagination: {
      handler() {
        this.changePagination();
      },
      deep: true
    }
  },
  destroyed() {
    this.clearTable();
  },
  methods: {
    getLicensePlate({veiculo, veiculoTransportadora}) {
      if(veiculo)
        return veiculo.placa

      if(veiculoTransportadora)
        return veiculoTransportadora.veiculo.placa

      return '-'
    },

    isIndeferido({ status }) {
      return status === STATUS_INDEFERIDO
    },

    getMotivoIndeferimento(item) {
      const key = MOTIVO_INDEFERIMENTO_KEYS.find(
        k => typeof item[k] === 'string' && item[k].trim()
      )

      return key ? item[key].trim() : 'Motivo não informado.'
    },

    changePagination() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.pagination;
      let input = { ...this.table.paginate.input };

      if (
        this.$route.query.hasOwnProperty("status") &&
        this.$route.query.hasOwnProperty("type")
      ) {
        const { status, type } = this.$route.query;
        input = {
          ...this.table.paginate.input,
          status,
          tipoPedido: type
        };
      }

      const paginate = {
        ...this.table.paginate,
        input,
        inputPage: {
          page: page,
          size: itemsPerPage,
          sort: sortBy.length > 0 ? sortBy : ["id"],
          ascendingSort: sortDesc.length > 0 ? sortDesc[0] : false
        }
      };

      this.setTablePagination(paginate);
      this.search();
    },
    goToDetail({ id }) {
      this.$router.push({
        name: "pedidos-detail",
        params: { id }
      });
    },
    search() {
      this.setTableIsLoading(true)
      PedidoService.page(this.table.paginate).subscribe(({content, totalElements})=>{
        this.setTableContent(content)
        this.setTableTotals(totalElements)
        this.setTableIsLoading(false)
      }, (error)=>{
        this.setTableIsLoading(false)
      })
    },
    ...actions,
  },
};
</script>

<style lang="scss" scoped>
.actions-cell {
  display: flex;
  align-items: center;
  white-space: nowrap;

  > * + * {
    margin-left: 4px;
  }

  a {
    display: inline-flex;
  }
}

.actions-cell__spacer {
  display: inline-block;
  width: 28px;
}

.indeferimento-card {
  &__title {
    font-size: 14px;
    font-weight: 600;
    padding: 12px 16px 4px;
    word-break: normal;
  }

  &__text {
    padding: 0 16px 12px;
    font-size: 13px;
    white-space: pre-line;
  }
}
</style>
